import React from "react";

export default props => (
<div className="login-redirect">
    <h1>LOGIN REQUIRED</h1>
    <p>Please ask your administrator for assistance.</p>
</div>
);
